import { PostList } from '@/components/postList';
import { Main } from '@/layouts/main';
import sanityClient from '@/lib/sanityClient';
import { postsQuery } from '@/lib/sanityQueries';

import type { Post } from '@/types';
import type { NextPage } from 'next';
import Head from 'next/head';

interface Props {
  posts: Post[];
}

const Writing: NextPage<Props> = ({ posts }) => {
  return (
    <>
      <Head>
        <title>chrisbailey.dev - writing</title>
        <meta name="description" content="list of articles written by chris bailey" />
      </Head>
      <Main>
        <h2 className="text-3xl font-extrabold text-indigo-500 lowercase">
          writings
        </h2>
        <PostList posts={posts} />
      </Main>
    </>
  );
};

export async function getStaticProps() {
  const posts: Post[] = await sanityClient.fetch(postsQuery);
  return {
    props: { posts }
  };
}

export default Writing;
